import { useState, useEffect } from "react";
import Block from '../new/block1';

// Composant EditableBlockList
const EditableBlockList = ({ onClinicChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [blocks, setBlocks] = useState([]);   // Questions dynamiques
  const [questions, setQuestions] = useState([
    { label: 'Nom examen', content: 'Resultat', file: null }
  ]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Ajouter un bloc de question dynamique
  const handleAddBlock = () => {
    const newBlock = { label: `New Question ${Date.now()}`, id: Date.now(), response: "" };
    setBlocks((prevBlocks) => {
      const updatedBlocks = [...prevBlocks, newBlock];
      // Mettre à jour les questions et les blocs dans le parent
      onClinicChange([...questions, ...updatedBlocks], 'clinical_exam');
      return updatedBlocks;
    });
  };

  // Gérer le changement du label dans les blocs dynamiques
  const handleBlockLabelChange = (blockId, newLabel) => {
    const updatedBlocks = blocks.map(block =>
      block.id === blockId ? { ...block, label: newLabel } : block
    );
    setBlocks(updatedBlocks);

    // Envoyer les données mises à jour au parent
    onClinicChange([...questions, ...updatedBlocks], 'clinical_exam');
  };
  

  // Gérer le changement de contenu dans les blocs
  const handleBlockContentChange = (blockId, newContent) => {
    const updatedBlocks = blocks.map(block =>
      block.id === blockId ? { ...block, response: newContent } : block
    );
    setBlocks(updatedBlocks);

    // Envoyer les données mises à jour au parent
    onClinicChange([...questions, ...updatedBlocks], 'clinical_exam');
  };

  useEffect(() => {
    // Initialiser les questions par défaut dans le parent
    onClinicChange([...questions, ...blocks], 'clinical_exam');
  }, [questions, blocks]);

  const handleBlockFileChange = (blockId, file) => {
    const updatedBlocks = blocks.map(block =>
      block.id === blockId ? { ...block, file } : block
    );
    setBlocks(updatedBlocks);
    onClinicChange([...questions, ...updatedBlocks], 'clinical_exam');
  };
  

  const handleQuestionFileChange = (index, file) => {
    const updatedQuestions = questions.map((q, i) =>
      i === index ? { ...q, file } : q
    );
    setQuestions(updatedQuestions);
    onClinicChange([...updatedQuestions, ...blocks], 'clinical_exam');
  };

  return (
    <div>
      <div className="position-relative">
        <p
          className="py-3 fw-bold text-center"
          style={{ background: '#1A5D1A47', borderRadius: '15px' }}
          onClick={toggleDropdown}
        >
          Clinical examinations
        </p>
        <i
          className="bi bi-caret-down-fill pos1"
          style={{ color: '#1A5D1A' }}
        ></i>
      </div>

      {isOpen && (
        <div className="row m-4">
          <p className="ms-4 fw-bold">Notez les résultats des examens clinique effectués </p>

          {/* Affichage des questions par défaut */}
          {questions.map((question, index) => (
            <div key={index} className="col-12 mx-auto mb-3">
              <Block
                initialLabel={question.label}
                initialContent={question.content}
                onContentChange={(newContent) => {
                  const updatedQuestions = questions.map((q, i) =>
                    i === index ? { ...q, content: newContent } : q
                  );
                  setQuestions(updatedQuestions);
                  onClinicChange(updatedQuestions, 'clinical_exam');
                }}
                onLabelChange={(newLabel) => {
                  const updatedQuestions = questions.map((q, i) =>
                    i === index ? { ...q, label: newLabel } : q
                  );
                  setQuestions(updatedQuestions);
                  onClinicChange(updatedQuestions, 'clinical_exam');
                }}
              />
              <input
                type="file"
                className="form-control mt-2 mb-3"
                onChange={(e) => handleQuestionFileChange(index, e.target.files[0])}
              />
            </div>
          ))}

          {/* Affichage des blocs dynamiques */}
          {blocks.map((block) => (
            <div key={block.id} className="col-12 mx-auto mb-3">
              <Block
                initialLabel={block.label}
                initialContent={block.response || ""}
                onContentChange={(newContent) => handleBlockContentChange(block.id, newContent)}
                onLabelChange={(newLabel) => handleBlockLabelChange(block.id, newLabel)}
              />
              <input
                type="file"
                className="form-control mt-2 mb-3"
                onChange={(e) => handleBlockFileChange(block.id, e.target.files[0])}
              />
            </div>
          ))}

          <div className="d-flex justify-content-end">
            <button
              className="btn btn-prim"
              style={{ color: '#0056B3' }}
              onClick={handleAddBlock} // Ajouter un nouveau bloc de question
            >
              <i className="bi bi-plus-circle-fill me-2"></i>
              <span style={{ textDecoration: 'underline' }}>Add Examen</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditableBlockList;
